"use client";

export default function GlobalError() {
  return (
    <html lang="fr">
      <body>Une erreur est survenue.</body>
    </html>
  );
}
